import {useLazyQuery} from '@apollo/client';
import {itemStatusQueries} from 'api/graphql-queries/itemStatuses';
import {ItemDataUpdateOrderAndStatuesResponse, ItemStatus, ItemStatusRequest, ItemStatusResponse} from 'models/board';
import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {itemStatusSelector, setItemStatuses, setStatusItemsCount} from 'store/itemStatues';

export const useItemStatuesInRedux = () => {
    const {
        selectedStatus: selectedStatusInRedux,
        statuses: statusesInRedux,
        statusItemsCount,
    } = useSelector(itemStatusSelector);
    const dispatch = useDispatch();

    const selectedStatus = useMemo(() => {
        return selectedStatusInRedux;
    }, [selectedStatusInRedux]);

    const statuses = useMemo(() => {
        return statusesInRedux;
    }, [statusesInRedux]);

    const setItemStatusesInRedux = useCallback(
        (value: ItemStatus[]) => {
            dispatch(setItemStatuses(value));
        },
        [dispatch],
    );
    const setStatusItemsCountInRedux = useCallback(
        (value: {[key: string]: number}) => {
            dispatch(setStatusItemsCount(value));
        },
        [dispatch],
    );
    const handleUpdateItemStatusCountAfterUpdate = useCallback(
        (value: ItemDataUpdateOrderAndStatuesResponse) => {
            console.log('value', value, statusItemsCount);

            const copy = {...statusItemsCount};

            if (value.prevStatusId && value.prevStatusId !== value.newStatusId) {
                copy[value.prevStatusId] = (statusItemsCount[value.prevStatusId] || 0) - 1;
                copy[value.newStatusId] = (statusItemsCount[value.newStatusId] || 0) + 1;
            } else {
                copy[value.newStatusId] = (statusItemsCount[value.newStatusId] || 0) + 1;
            }
            console.log('copy', copy);

            dispatch(setStatusItemsCount(copy));
        },
        [dispatch, statusItemsCount],
    );

    return {
        selectedStatus,
        statuses,
        setStatusItemsCountInRedux,
        setItemStatusesInRedux,
        handleUpdateItemStatusCountAfterUpdate,
    };
};

export const useGetAllItemStatusesByBoardId = () => {
    const [refetch, {data, loading}] = useLazyQuery<ItemStatusResponse, ItemStatusRequest>(
        itemStatusQueries.ITEM_STATUSES_BY_BOARD_ID,
    );
    return {
        getAllItemStatuses: refetch,
        getAllStatusessResponse: data?.itemStatuses,
        getAllStatusesLoading: loading,
    };
};
